import fetchClient from "../utils/http-common";
import { SERVER_API_URL } from '../config/Constants'

// Today's playable puzzle. The response never includes the solution — moves are
// validated server-side (see step) so it can't be read off the wire.
const getDaily = () => {
  return fetchClient.get(`${SERVER_API_URL}/puzzles/daily.json`);
};

// Validate one attacker move against the (unique) solution line.
//   ply  : index of this move in the solution (0, 2, 4, ...)
//   move : "from,to" of the piece the player just dropped
// Returns { correct, solved?, reply? }. The solution never reaches the client.
const step = (puzzleId, ply, move) => {
  return fetchClient.post(`${SERVER_API_URL}/puzzles/${puzzleId}/step.json`, {
    ply,
    move,
  });
};

export default {
  getDaily,
  step,
};
